/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiCallOut, EuiLink } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

export const ConsolePrivacyWarning: React.FC = () => (
  <EuiCallOut
    data-test-id='api-console.privacy-warning'
    color='warning'
    iconType='alert'
    title={
      <FormattedMessage id='apiConsole.privacyWarning.title' defaultMessage='Privacy warning' />
    }
  >
    <FormattedMessage
      id='apiConsole.privacyWarning'
      defaultMessage='Written customer consent is required when accessing customer data, including regular indices and system indices. See Handling Customer Data {wiki} for more guidance.'
      values={{
        wiki: (
          <EuiLink href='https://ela.st/ac-api-consense' target='_blank'>
            <FormattedMessage id='apiConsole.handling-customer-data-wiki' defaultMessage='wiki' />
          </EuiLink>
        ),
      }}
    />
  </EuiCallOut>
)
